import React, { useState, useEffect } from 'react'
import { CheckCircle, Circle, Sparkles } from 'lucide-react'

const EXTRACTING_STEPS = [
  'Reading document structure…',
  'Locating exchanger and buyer…',
  'Extracting sale price and dates…',
  'Cross-referencing Sales Hub…',
]

interface SaleNeelaExtractingProps {
  fileName: string
  documentLabel?: string
}

export const SaleNeelaExtracting: React.FC<SaleNeelaExtractingProps> = ({ fileName, documentLabel }) => {
  const heading = documentLabel
    ? `Neela is reading your ${documentLabel}…`
    : 'Neela is reading your Sales & Purchase Agreement…'
  const ariaLabel = documentLabel
    ? `Neela is reading your ${documentLabel}`
    : 'Neela is reading your Sales document'
  const [stepIndex, setStepIndex] = useState(0)
  useEffect(() => {
    const timer = setInterval(() => {
      setStepIndex((prev) => Math.min(prev + 1, EXTRACTING_STEPS.length - 1))
    }, 500)
    return () => clearInterval(timer)
  }, [])
  return (
    <div
      className="rounded-xl border border-green-200 dark:border-green-700 bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 p-5"
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
      data-testid="sale-neela-extracting"
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-100 dark:bg-green-800/40 flex items-center justify-center">
          <Sparkles
            className="h-5 w-5 text-green-600 dark:text-green-400 animate-pulse"
            aria-hidden="true"
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-green-900 dark:text-green-100 mb-0.5">
            {heading}
          </p>
          <p className="text-xs text-green-600 dark:text-green-400 truncate mb-3">{fileName}</p>
          <div className="space-y-1.5">
            {EXTRACTING_STEPS.map((step, index) => (
              <div key={step} className="flex items-center gap-2">
                {index < stepIndex ? (
                  <CheckCircle
                    className="h-3 w-3 text-emerald-500 flex-shrink-0"
                    aria-hidden="true"
                  />
                ) : index === stepIndex ? (
                  <span
                    className="h-3 w-3 rounded-full border-2 border-green-500 border-t-transparent animate-spin flex-shrink-0"
                    aria-hidden="true"
                  />
                ) : (
                  <Circle
                    className="h-3 w-3 text-green-300 dark:text-green-700 flex-shrink-0"
                    aria-hidden="true"
                  />
                )}
                <span
                  className={
                    index <= stepIndex
                      ? 'text-xs text-green-800 dark:text-green-200'
                      : 'text-xs text-green-400 dark:text-green-600'
                  }
                >
                  {step}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
